import { PATH_ROOT } from "@/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useContractorLimitScheduleReportBreadcrumb = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("reports.navigation.contractorLimitScheduleReport") },
    ],
    [t],
  );
};

export { useContractorLimitScheduleReportBreadcrumb };
